import React from 'react';
import { componentTypes, Snippet } from '@white-nl/instantsearch-components';
import Coin from '../../ui/icons/Coin';
import Newspaper from '../../ui/icons/Newspaper';
import Megaphone from '../../ui/icons/Megaphone';
import FileText from '../../ui/icons/FileText';
import CloudArrowDown from '../../ui/icons/CloudArrowDown';

export default function Hit({ hit, additionalData }: componentTypes.HitProps) {
  const {
    title,
    url,
    searchType,
    postDate,
    fileType,
    fileSize,
    attachment,
    _snippetResult,
  } = hit;

  const { locale, search } = additionalData;

  let date = null;
  if (postDate) {
    date = new Date(postDate).toLocaleDateString(locale, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  let snippetAttribute: string | null = additionalData.siteHandle === 'corporate_asnbank_nl' ? 'content_nl' : 'content_en';
  if (searchType === 'document') {
    if (_snippetResult) {
      if (_snippetResult.attachment) {
        snippetAttribute = 'attachment.content';
      } else if (_snippetResult.content_nl || _snippetResult.content_en) {
        snippetAttribute = additionalData.siteHandle === 'corporate_asnbank_nl' ? 'content_nl' : 'content_en';
      } else {
        snippetAttribute = null;
      }
    }
  }

  return (
    <div className="bg-white flex flex-col gap-16 items-start justify-start relative w-full not-first:pt-8 not-last:pb-8 not-last:border-b not-last:border-gray-950/10">
      <div className="flex flex-col gap-8 items-start justify-start relative w-full">
        <div className="flex flex-col gap-3 items-start justify-start relative w-full">
          <div className="flex flex-col justify-center not-italic relative order-2">
            <h3 className="font-secondary font-bold text-2xl text-green-500 theme-contrast:text-gray-950 leading-title">
              <a
                  href={url}
                  className="no-underline hover:underline hover:decoration-green-500"
                  target={searchType === 'document' || searchType === 'press' ? '_blank' : '_self'}
                  rel={searchType === 'document' || searchType === 'press' ? 'noopener noreferrer' : undefined}
              >
                {title}
              </a>
            </h3>
          </div>
          <div className="bg-white flex gap-8 items-center justify-center relative rounded-full order-1">
            <div className="flex gap-3 items-end justify-start leading-none not-italic relative text-gray-500 text-xs whitespace-nowrap">
              <div className="flex flex-col justify-center relative">
                {searchType === 'investorRelations' && (
                  <Coin iconClass="w-3.5" />
                )}
                {searchType === 'page' && (
                  <Newspaper iconClass="w-3.5" />
                )}
                {searchType === 'press' && (
                  <Megaphone iconClass="w-3.5" />
                )}
                {searchType === 'document' && (
                  <FileText iconClass="w-3.5" />
                )}
              </div>
              <div className={`flex flex-col justify-center relative ${date !== null && 'border-r border-gray-500 pr-3'}`}>
                <p className="leading-none whitespace-pre">{Craft.t(search, searchType)}</p>
              </div>
              {date !== null && (
                <div className="flex flex-col justify-center relative">
                  <p className="leading-none whitespace-pre">{date}</p>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col items-start justify-start not-italic relative w-full order-3">
            <div className="flex-col justify-center max-w-full overflow-ellipsis overflow-hidden relative text-gray-900 text-base font-normal">
              {snippetAttribute ?
                <Snippet
                  hit={hit}
                  attribute={snippetAttribute}
                  classNames={{
                    highlighted: 'bg-yellow-400 theme-contrast:bg-gray-950 theme-contrast:text-white',
                    nonHighlighted: 'only:line-clamp-5',
                  }}
                /> : attachment ? <div className="line-clamp-5">{attachment.content}</div> : null
              }
            </div>
            <div className="flex flex-col justify-center max-w-full overflow-ellipsis overflow-hidden relative">
              <a
                href={url}
                className="font-semibold text-xs lg:text-base leading-text-lg not-italic text-brown-500 theme-contrast:text-gray-950 overflow-ellipsis break-words"
                target={searchType === 'document' || searchType === 'press' ? '_blank' : '_self'}
              >
                <div className="inline-flex max-w-full flex-col-reverse lg:flex-row-reverse">
                  {searchType === 'document' && (
                    <div className="text-gray-500 text-xs/none inline-flex lg:ml-6 gap-2 items-center shrink-0 peer">
                      <CloudArrowDown iconClass="w-4.5" />
                      <span className="uppercase">{fileType}</span>
                      {fileSize && (
                        <span>{`(${fileSize})`}</span>
                      )}
                    </div>
                  )}
                  <span className="underline hover:no-underline peer-hover:no-underline">{url.split('?v=')[0]}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
